export enum EnumOptionStatus {
  STOPSALE = 'STOPSALE',
  AVAILABLE = 'AVAILABLE',
}
